import PropTypes from "prop-types";
import React from "react";
import Masonry from "react-masonry-component";
import DisplayMedia from "./DisplayMedia.jsx";
import ProfileCard from "./ProfileCard.jsx";

class FacebookMasonry extends React.Component {
  scrollElement(element, scrollPosition, duration) {
    let style = element.style;
    // setup CSS transition duration and easing function
    style.webkitTransition = style.transition = duration + "s";
    style.webkitTransitionTimingFunction = style.TransitionTimingFunction =
      "linear";

    // use translate3d to force hardware acceleration
    style.webkitTransform = style.Transform =
      "translate3d(0, " + -scrollPosition + "px, 0)";
  }

  render() {
    let profilePic = this.props.profilePic;
    let name = this.props.name;
    let masonryOptions = {
      transitionDuration: 0
    };

    let childElements = this.props.items.map(function(item, key) {
      console.log("ITEM=", item);
      let media = "";

      let profile = (
        <ProfileCard
          profilePic={profilePic}
          name={name}
          time={item.created_time}
          theme={this.props.theme}
        />
      );

      if (
        item.attachments !== "undefined" &&
        item.attachments !== undefined &&
        item.attachments
      ) {
        media = <DisplayMedia attachments={item.attachments.data} />;
      }

      return (
        <li className="post" key={key}>
          {profile}
          <p>{item.message}</p>
          {media}
        </li>
      );
    });

    return (
      <Masonry
        className={"masonry-container"} // default ''
        elementType={"ul"} // default 'div'
        options={masonryOptions} // default {}
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
      >
        {childElements}
      </Masonry>
    );
  }
}

FacebookMasonry.propTypes = {
  profilePic: PropTypes.string,
  name: PropTypes.string,
  shortName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      attachments: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          media: PropTypes.shape({
            image: PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
              src: PropTypes.string
            })
          }),
          target: PropTypes.shape({
            url: PropTypes.string
          }),
          title: PropTypes.string,
          type: PropTypes.string,
          url: PropTypes.string
        })
      ),
      created_time: PropTypes.string,
      id: PropTypes.string,
      likes: PropTypes.shape({
        data: PropTypes.array,
        summary: PropTypes.object
      }),
      link: PropTypes.string,
      message: PropTypes.string
    })
  ),
  color: PropTypes.string,
  bgColor: PropTypes.string,
  theme: PropTypes.string
};

export default FacebookMasonry;
